import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import styled from "styled-components"

const Bon = () => {
    const FiugreImage = styled.figure`
        max-width: 200px;
        margin: 1rem 0;
    `
  const data = useStaticQuery(graphql`
    query Bon {
      bon: file(relativePath: { eq: "bon.png" }) {
        id
        childImageSharp {
          fixed(width: 200, quality: 100) {
            ...GatsbyImageSharpFixed_noBase64
          }
          fluid(maxWidth: 200, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  console.log(data)
  return (
    <FiugreImage>
      <Img fixed={data.bon.childImageSharp.fixed} />
    </FiugreImage>
  )
}

export default Bon
